import { useState, useEffect } from "react";
import { useRef } from "react";
import Button from "react-bootstrap/Button";
import moment from "moment";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Spinner } from "react-bootstrap";
import "../../../src/stylecss/mainpage.css";
import "swiper/css";
import MainLogo from "../../assets/boj-images/dark_boj.png";
import backgroundImage from "../../assets/boj-images/new_side_banner.jpeg";
import "animate.css/animate.min.css";
import { message } from "antd";
import { compressImage } from "../../utils/compressImage";
import useFetchData from "../../common/useFetchData";
import CommonFileUploader from "../../common/CommonFileUploader";
import PrintPage from "./PrintPage";
import useBranding from "../../hooks/useBranding";
const categoriesList = [
    "Gold Jewellery",
    "Lightweight Diamonds",
    "Open Polki",
    "Bridesmaid Diamonds",
    "Gemstone Jewellery",
    "Loose Stones",
];
const allowedTypes = [
    "image/png",
    "image/jpg",
    "image/jpeg",
    // "image/heif",
    // "image/heic"
];

const styles = {
    imageDiv: {
        marginTop: "8px",
        width: "100%",
        padding: "10px",
        height: "200px",
        border: "1px solid #ddd",
        borderRadius: "6px",
        overflow: "hidden",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "#fafafa",
    },

    previewImg: {
        maxWidth: "100%",
        maxHeight: "100%",
        objectFit: "contain",
    },

    fileLabel: {
        overflow: "hidden",
        height: "42px",
    },

    clipImg: {
        height: "20px",
        width: "auto",
        marginRight: "8px",
    },
};

const BuyerVisitorForm = ({ preloadedData = null }) => {

    const { logoUrl, backgroundUrl } = useBranding();

    const [show, setShow] = useState(true);

    const { barcode: paramBarcode } = useParams();
    // If we have preloadedData, we use that. Otherwise we look for a barcode in URL.
    // However, the new flow uses preloadedData from BuyerLogin.
    const barcode = preloadedData?.barcode || paramBarcode;

    const isBuyerFlow = Boolean(barcode);

    // 🔒 Lock all exhibitor-filled fields when buyer opens via barcode
    const lockBuyerFields = isBuyerFlow;

    const [memberType, setMemberType] = useState(null);
    const [checkInDate, setCheckInDate] = useState("");
    const [checkOutDate, setCheckOutDate] = useState("");
    const normalizedMemberType = memberType?.toLowerCase().trim();
    const [nightsChoice, setNightsChoice] = useState(2);

    const isGoldMember = normalizedMemberType === "gold";
    const HOTEL_START_DATE = (isGoldMember || nightsChoice === 1) ? "2026-11-17" : "2026-11-16";
    const HOTEL_END_DATE = "2026-11-20";
    const TICKTING_START_DATE = "2026-11-16";
    const TICKTING_END_DATE = "2026-11-20";

    const memberRules = {
        diamond: { hotel: true, maxNights: 2, travel: true },
        platinum: { hotel: true, maxNights: 2, travel: true },
        gold: { hotel: true, maxNights: 1, travel: false },
        silver: {hotel: false, maxNights: 0, travel: false}
    };

    const memberConfig = memberRules[normalizedMemberType] ?? { hotel: false, maxNights: 0, travel: false };

    useEffect(() => {
        if (normalizedMemberType === "silver") {
            setNightsChoice(0);
        } else if (normalizedMemberType === "gold") {
            setNightsChoice(1);
        } else if (normalizedMemberType === "diamond" || normalizedMemberType === "platinum") {
            setNightsChoice(2);
        }
    }, [normalizedMemberType]);


    const showHotelSection = Boolean(memberConfig?.hotel);
    const maxHotelNights = memberConfig?.maxNights || 0;
    const requiresTravelTicket = Boolean(memberConfig?.travel);

    const [registrationCompleted, setRegistrationCompleted] = useState(false);
    const [accessAllowed, setAccessAllowed] = useState(null); // null = loading
    const [accessError, setAccessError] = useState("");
    const [prefilledData, setPrefilledData] = useState(null);
    const isPrefilledBuyer = Boolean(
        prefilledData?.visitor_first_name ||
        prefilledData?.visitor_last_name ||
        prefilledData?.company_email ||
        prefilledData?.company_name
    );
    const [prefilledCompanyEmail, setPrefilledCompanyEmail] = useState(false);
    const [prefilledCompanyNumber, setPrefilledCompanyNumber] = useState(false);
    const [prefilledStoreName, setPrefilledStoreName] = useState(false);
    const [prefilledFirstName, setPrefilledFirstName] = useState(false);
    const [prefilledLastName, setPrefilledLastName] = useState(false);
    const [prefilledVisitorEmail, setPrefilledVisitorEmail] = useState(false);
    const [prefilledVisitorMobile, setPrefilledVisitorMobile] = useState(false);
    const [prefilledCompanyName, setPrefilledCompanyName] = useState(false);
    const [alreadyRegistered, setAlreadyRegistered] = useState(false);
    const [prefilledPhoto, setPrefilledPhoto] = useState(false);
    const [prefilledIdProofFront, setPrefilledIdProofFront] = useState(false);
    const [prefilledIdProofBack, setPrefilledIdProofBack] = useState(false);
    const [prefilledStoreImage, setPrefilledStoreImage] = useState(false);
    const [prefilledVisitingCard, setPrefilledVisitingCard] = useState(false);
    const [departureTicket, setDepartureTicket] = useState(null);
    const [prefilledDepartureTicket, setPrefilledDepartureTicket] = useState(false);
    const [departureLoading, setDepartureLoading] = useState(false);


    const photoInputRef = useRef(null);
    const idFrontInputRef = useRef(null);
    const idBackInputRef = useRef(null);
    const storeInputRef = useRef(null);
    const visitingCardInputRef = useRef(null);
    const departureInputRef = useRef(null);







    const [category, setCategory] = useState("visitor");
    const [companyName, setCompanyName] = useState("");
    const [mobileError, setMobileError] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [successMessage, setSuccessMessage] = useState(false);
    const navigate = useNavigate();
    const [emailError, setEmailError] = useState("");
    const [CompanyEmailError, setCompanyEmailError] = useState('')
    const [CompanyNumberError, setCompanyNumberError] = useState('')

    const [showError, setShowError] = useState("");
    const handleClose = () => setShow(false);
    const [registrationDate, setRegistrationDate] = useState("");
    const [duplicateError, setDuplicateError] = useState(null);
    const { showData, loading: visibilityLoading, error } = useFetchData();
    const [showSuccessPage, setShowSuccessPage] = useState(false);
    const [gst_data_present, setGst_data_present] = useState(null);
    //const [gst_certificate, setGstCertificate] = useState();


    const [storeImage, setStoreImage] = useState();
    const [selectedCategories, setSelectedCategories] = useState([]);
    const hasPrefilledCategories = selectedCategories.length > 0 && isBuyerFlow;
    const [storeName, setStoreName] = useState("");
    const [companyEmail, setCompanyEmail] = useState("");
    const [companyAddress, setCompanyAddress] = useState('');
    const [companyNumber, setCompanyNumber] = useState("");
    const [zip, setZip] = useState('');
    const [country, setCountry] = useState("");
    const [city, setCity] = useState("");
    const [state, setState] = useState("");
    const [visitorFirstName, setVisitorFirstName] = useState('');
    const [visitorLastName, setVisitorLastName] = useState('');
    const [visitorMobileNo, setVisitorMobileNo] = useState("");
    const [visitorEmailId, setVisitorEmailId] = useState("");
    const [photo, setPhoto] = useState();
    const [idProofFront, setIDProofFront] = useState();
    const [idProofBack, setIDProofBack] = useState();
    const [photoLoading, setPhotoLoading] = useState(false);
    const [idFrontLoading, setIdFrontLoading] = useState(false);
    const [idBackLoading, setIdBackLoading] = useState(false);
    const [storeImgLoading, setStoreImgLoading] = useState(false);
    const [visitingCardLoading, setVisitingCardLoading] = useState(false);
    const [gst_number, setGst_number] = useState("");
    const [visitingCard, setVisitingCard] = useState("");
    const [selectedShow, setSelectedShow] = useState("");
    // Travel (Diamond only)
    const [travelTicket, setTravelTicket] = useState(null);
    const [travelMode, setTravelMode] = useState("Flight");
    const [travelLoading, setTravelLoading] = useState(false);
    const [arrivalDate, setArrivalDate] = useState("");
    const [departureDate, setDepartureDate] = useState("");
    const [remarks, setRemarks] = useState("");

    // Flight Details
    const [arrivalFlightNo, setArrivalFlightNo] = useState("");
    const [departureFlightNo, setDepartureFlightNo] = useState("");
    const [arrivalTerminal, setArrivalTerminal] = useState("");
    const [departureTerminal, setDepartureTerminal] = useState("");
    const [arrivalTime, setArrivalTime] = useState("");
    const [departureTime, setDepartureTime] = useState("");

    const handleTravelTicket = (e) =>
        validateImage(e, setTravelTicket, setTravelLoading);

    const handleDepartureTicket = (e) =>
        validateImage(e, setDepartureTicket, setDepartureLoading);

    const hasPhoto = Boolean(photo);
    const hasIdFront = Boolean(idProofFront);
    const hasIdBack = Boolean(idProofBack);
    const hasStoreImage = Boolean(storeImage);
    const hasVisitingCard = Boolean(visitingCard);
    const [prefilledCategories, setPrefilledCategories] = useState([]);










    const regex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;
    function checkRegex(input) {
        return regex.test(input);
    }

    function convertToUpperCase(input) {
        return input.replace(/[a-z]/gi, (char) => char.toUpperCase());
    }

    const validateImage = async (e, setState, setUploadLoading) => {
        const file = e.target.files[0];

        if (!file) return;

        setUploadLoading(true);

        try {
            const fileName = file.name.toLowerCase();
            const fileType = file.type;

            const isValidMime = allowedTypes.includes(fileType);
            const isValidExtension =
                fileName.endsWith(".jpg") ||
                fileName.endsWith(".jpeg") ||
                fileName.endsWith(".png")
            // ||
            // fileName.endsWith(".heif") ||
            // fileName.endsWith(".heic");

            if (!isValidMime && !isValidExtension) {
                message.error("Only JPG, JPEG, PNG images are allowed");
                e.target.value = "";
                return;
            }

            let updatedFile = file;

            if (file.size > 2 * 1024 * 1024) {
                updatedFile = await compressImage(file);
            }

            setState(updatedFile);

        } catch (err) {
            console.error("validateImage error:", err);
            message.error("Something went wrong. Try again.");
        } finally {
            setUploadLoading(false);
        }

    };
    const resetGstDependentFields = () => {
        setCompanyAddress("");
        setCity("");
        setZip("");
        setCountry("");
        setCompanyName("");
        setState("");
        setStoreName("");
        setDuplicateError(false);
        setGst_data_present(null);
    };

    const handleGstNumberChange = (e) => {

        let value = e.target.value.toUpperCase();

        value = value.replace(/[^A-Z0-9]/g, "");

        if (value.length > 15) return;

        for (let i = 0; i < value.length; i++) {
            const ch = value[i];
            const pos = i + 1;

            if (pos <= 2 && !/[0-9]/.test(ch)) return;
            if (pos > 2 && pos <= 7 && !/[A-Z]/.test(ch)) return;
            if (pos > 7 && pos <= 11 && !/[0-9]/.test(ch)) return;
            if (pos === 12 && !/[A-Z]/.test(ch)) return;
            if (pos === 13 && !/[1-9A-Z]/.test(ch)) return;
            if (pos === 14 && ch !== "Z") return;
            if (pos === 15 && !/[0-9A-Z]/.test(ch)) return;
        }

        setGst_number(value);

        if (value === "") {
            setShowError("Please enter GST");
            resetGstDependentFields();
            return;
        }

        if (value.length === 15 && !checkRegex(value)) {
            setShowError("Provide Valid GSTIN");
            resetGstDependentFields();
            return;
        }
        setShowError("");
    };


    useEffect(() => {
        // If we already have preloaded/verified data, we assume access is allowed.
        if (preloadedData) {
            setAccessAllowed(true);
            setAccessError("");
            return;
        }

        if (!barcode) return;

        axios
            .get(`${process.env.REACT_APP_API_END_POINT}/barcode-check/${barcode}`)
            .then((res) => {

                console.log("BARCODE CHECK RESPONSE:", res.data); // 🔍 debug

                if (res.data.allowed === true) {
                    setAccessAllowed(true);
                    setAccessError("");
                }
                else {
                    setAccessAllowed(false);

                    if (res.data.reason === "not_preapproved") {
                        setAccessError("Your registration is still pending approval.");
                    }
                    else if (res.data.reason === "not_buyer") {
                        setAccessError("This link is only for approved buyers.");
                    }
                    else if (res.data.reason === "member_type_missing") {
                        setAccessError("Your membership category has not been assigned yet.");
                    }
                    else if (res.data.reason === "invalid_barcode") {
                        setAccessError("Invalid registration link.");
                    }
                    else {
                        // fallback
                        setAccessError(res.data.message || "Invalid registration link.");
                    }
                }

            })
            .catch((err) => {
                console.error("barcode-check error:", err);
                setAccessAllowed(false);
                setAccessError("Invalid registration link.");
            });

    }, [barcode, preloadedData]);



    useEffect(() => {
        if ((!barcode && !preloadedData) || showSuccessPage) return;

        const handleBuyerData = (buyer) => {
            if (buyer.profile_completion_status === "completed") {
                setAlreadyRegistered(true);
                return;
            }

            // 🔒 store prefilled source
            setPrefilledData(buyer);

            // --- NORMALIZE DATA (Handle both flat and nested structures) ---
            const companyDetails = buyer.company_details || {};
            const userDetails = buyer.user_details || {};

            const cName = buyer.company_name || companyDetails.company_name || "";
            const sName = buyer.store_name || companyDetails.store_name || "";
            const gst = buyer.gst_number || companyDetails.gst_number || "";
            const cEmail = buyer.company_email || companyDetails.company_email || "";
            const cNumber = buyer.company_number || companyDetails.company_number || "";
            const cAddress = buyer.company_address || companyDetails.company_address || "";
            const sImage = buyer.store_image || companyDetails.store_image || null;

            const vFirstName = buyer.visitor_first_name || userDetails.first_name || "";
            const vLastName = buyer.visitor_last_name || userDetails.last_name || "";
            const vMobile = buyer.visitor_mobile_no || userDetails.mobile_number || "";
            const vEmail = buyer.visitor_email || userDetails.email || "";

            const bCity = buyer.city || "";
            const bState = buyer.state || "";
            const bCountry = buyer.country || "";
            const bZip = buyer.zip || buyer.zip_code || "";
            const bShow = buyer.show || "";

            if (bShow) {
                setSelectedShow(bShow);
            }


            // ---- TEXT DATA (LOCKED) ----
            setCompanyName(cName);
            setPrefilledCompanyName(Boolean(cName));
            setGst_number(gst);
            setCompanyEmail(cEmail);
            setPrefilledCompanyEmail(Boolean(cEmail));

            setCompanyNumber(cNumber);
            setPrefilledCompanyNumber(Boolean(cNumber));

            setCompanyAddress(cAddress);
            setCity(bCity);
            setState(bState);
            setCountry(bCountry);
            setZip(bZip);
            setStoreName(sName);
            setPrefilledStoreName(Boolean(sName));

            setVisitorFirstName(vFirstName);
            setPrefilledFirstName(Boolean(vFirstName));
            setVisitorLastName(vLastName);
            setPrefilledLastName(Boolean(vLastName));
            setVisitorMobileNo(vMobile);
            setPrefilledVisitorMobile(Boolean(vMobile));

            setVisitorEmailId(vEmail);
            setPrefilledVisitorEmail(Boolean(vEmail));

            // ---- JEWELLERY CATEGORIES ----
            try {
                if (buyer.jewellery_categories) {
                    const cats = Array.isArray(buyer.jewellery_categories)
                        ? buyer.jewellery_categories
                        : JSON.parse(buyer.jewellery_categories);

                    setPrefilledCategories(cats || []);   // 🔒 original visitor data
                    setSelectedCategories(cats || []);    // UI state
                } else {
                    setPrefilledCategories([]);
                    setSelectedCategories([]);
                }
            } catch {
                setPrefilledCategories([]);
                setSelectedCategories([]);
            }


            // ---- IMAGES (PREVIEW) ----
            setPhoto(buyer.photo || null);
            setPrefilledPhoto(Boolean(buyer.photo));

            setIDProofFront(buyer.id_proof_front || null);
            setPrefilledIdProofFront(Boolean(buyer.id_proof_front));

            setIDProofBack(buyer.id_proof_back || null);
            setPrefilledIdProofBack(Boolean(buyer.id_proof_back));

            setStoreImage(sImage);
            setPrefilledStoreImage(Boolean(sImage));

            setVisitingCard(buyer.visiting_card || null);
            setPrefilledVisitingCard(Boolean(buyer.visiting_card));

            setTravelTicket(buyer.travel_ticket || null);

            setDepartureTicket(buyer.departure_ticket || null);
            setPrefilledDepartureTicket(Boolean(buyer.departure_ticket));

            setDepartureTicket(buyer.departure_ticket || null);
            setPrefilledDepartureTicket(Boolean(buyer.departure_ticket));

            // ---- FLIGHT DETAILS ----
            const flights = buyer.prefered_travel_details || {};
            setArrivalFlightNo(flights.arrival_flight_no || "");
            setDepartureFlightNo(flights.departure_flight_no || "");
            setArrivalTerminal(flights.arrival_terminal || "");
            setDepartureTerminal(flights.departure_terminal || "");
            setArrivalTime(flights.arrival_time || "");
            setDepartureTime(flights.departure_time || "");
            setTravelMode(flights.travel_mode || "Flight");

            // ---- MEMBER TYPE ----
            const rawType = buyer.member_type || "";
            const normalized =
                rawType.toLowerCase().includes("diamond")
                    ? "diamond"
                    : rawType.toLowerCase().includes("platinum")
                        ? "platinum"
                        : rawType.toLowerCase().includes("gold")
                            ? "gold"
                            : rawType.toLowerCase().includes("silver")
                                ? "silver"
                                : null;

            setMemberType(normalized);
        };

        if (preloadedData) {
            handleBuyerData(preloadedData);
        } else {
            axios
                .then((res) => {
                    handleBuyerData(res.data.data);
                })
                .catch(() => {
                    message.error("Invalid or expired buyer link");
                });
        }

    }, [barcode, showSuccessPage, preloadedData]);



    useEffect(() => {
        console.log("hello i am here to see the test daeeed", (gst_number || "").length);


        if ((gst_number || "").length === 15 && checkRegex(gst_number || "")) {

            axios
                .get(
                    `${process.env.REACT_APP_API_END_POINT}/check-gst-validation/${gst_number}`
                )
                .then((resData) => {
                    console.log("gst find or not", resData.data);
                    if (resData.data?.flag === false) {
                        setShowError(resData.data.message);
                        resetGstDependentFields();
                        return;
                    }
                    setGst_data_present(resData.data);
                    setShowError("");
                    setCompanyName(prev => prev || resData.data.company);
                    setCompanyAddress(prev => prev || resData.data.address);
                    setCity(prev => prev || resData.data.city);
                    setZip(prev => prev || resData.data.pincode);
                    setState(prev => prev || resData.data.state);
                    setCountry(prev => prev || "India");
                    setStoreName(prev => prev || resData.data.company);

                    // }
                })
                .catch((err) => {
                    console.log("gst fetch validation ");
                    setShowError("Facing Problem While Fetching Error");
                    resetGstDependentFields();
                });
        }
    }, [gst_number]);

    const handlePhoto = (e) => validateImage(e, setPhoto, setPhotoLoading);

    const handleIDFront = (e) => validateImage(e, setIDProofFront, setIdFrontLoading);

    const handleIDBack = (e) => validateImage(e, setIDProofBack, setIdBackLoading);

    const handleStoreImage = (e) => validateImage(e, setStoreImage, setStoreImgLoading);

    const handleVistingCard = (e) => validateImage(e, setVisitingCard, setVisitingCardLoading);

    function validateGstNumber(gst_number) {
        // If gst_number is not empty, then perform the checks
        if (gst_number && (gst_number.length !== 15 || !checkRegex(gst_number))) {
            return false;
        }
        // If gst_number is empty, skip the checks and return true
        return true;
    }
    const isValid = validateGstNumber(gst_number);

    const getNightsCount = (checkIn, checkOut) => {
        if (!checkIn || !checkOut) return 0;

        const start = new Date(checkIn);
        const end = new Date(checkOut);

        const diffTime = end - start;
        return diffTime / (1000 * 60 * 60 * 24);
    };

    const getPrefilledStyle = (value) => {
        if (value !== null && value !== undefined && String(value).trim() !== "") {
            return {
                background: "#cdcdcd",
                color: "#000",
                opacity: 1            // 🔥 THIS IS THE FIX
            };
        }
        return { background: "#fff", color: "#000", opacity: 1 };
    };




    const handleSubmit = async () => {
        if (isLoading) return;

        if (!storeName) {
            return message.error("Store Name is mandatory");
        } else if (!companyName) {
            return message.error("Company Name is mandatory");
        } else if (!companyEmail) {
            return message.error("Company Email is mandatory");
        } else if (!gst_number) {
            return message.error("Gst Number is mandatory");
        } else if (!visitorFirstName) {
            return message.error("First Name is mandatory");
        } else if (!visitorLastName) {
            return message.error("Last Name is mandatory");
        } else if (!isValid) {
            return message.error("Fill Valid Gst Number");
        } else if (!visitorMobileNo) {
            return message.error("Mobile No. is mandatory");
        } else if (visitorMobileNo.length !== 10) {
            return message.error("Please Enter 10 Digit Mobile Number");
        } else if (!visitorEmailId) {
            return message.error("Email is mandatory");
        } else if (!companyAddress) {
            return message.error("Address is mandatory");
        } else if (!city) {
            return message.error("City is mandatory");
        } else if (!state) {
            return message.error("State is mandatory");
        } else if (!zip) {
            return message.error("Zip code is mandatory");
        } else if (!country) {
            return message.error("Country is mandatory");
        } else if (!storeImage) {
            return message.error("Store Image is mandatory");
        } else if (!photo) {
            return message.error("Photo is mandatory");
        } else if (!idProofFront) {
            return message.error("ID Proof Front is mandatory");
        } else if (!idProofBack) {
            return message.error("ID Proof Back is mandatory");
        } else if (!selectedShow) {
            return message.error("Show is mandatory");
        }

        // ✅ Diamond-only validation
        if (showHotelSection) {
            if (!checkInDate || !checkOutDate) {
                return message.error("Please select both check-in and check-out dates");
            }

            const nights = getNightsCount(checkInDate, checkOutDate);

            if (nights <= 0) {
                return message.error("Check-out date must be after check-in date");
            }

            if (nights > nightsChoice) {
                return message.error(
                    `You are entitled to a complimentary stay of up to ${nightsChoice} night${nightsChoice > 1 ? "s" : ""} only`
                );
            }
        }

        // Travel validation (Diamond + Platinum)
        if (requiresTravelTicket && travelMode === "Flight") {
            if (!travelTicket) {
                return message.error(
                    `${normalizedMemberType.charAt(0).toUpperCase() + normalizedMemberType.slice(1)} members must upload travel ticket`
                );
            }
            if (!arrivalDate) return message.error("Arrival Date is mandatory");
            if (!departureDate) return message.error("Departure Date is mandatory");
            if (!arrivalFlightNo) return message.error("Arrival Flight No is mandatory");
            if (!departureFlightNo) return message.error("Departure Flight No is mandatory");
            if (!arrivalTerminal) return message.error("Arrival Terminal is mandatory");
            if (!departureTerminal) return message.error("Departure Terminal is mandatory");
            if (!arrivalTime) return message.error("Arrival Time is mandatory");
            if (!departureTime) return message.error("Departure Time is mandatory");
        }


        try {
            setIsLoading(true);

            const formData = new FormData();

            formData.append("company_name", companyName);
            formData.append("store_name", storeName);
            formData.append("company_email", companyEmail);
            formData.append("company_number", companyNumber);
            formData.append("gst_number", gst_number);
            formData.append("city", city);
            formData.append("state", state);
            formData.append("country", country);
            formData.append("zip_code", zip);   // 🔥 THIS FIXES ZIP
            formData.append("company_address", companyAddress);
            formData.append("store_image", storeImage);
            formData.append("show", selectedShow);

            formData.append(
                "jewellery_categories",
                JSON.stringify(selectedCategories)
            );

            formData.append("visitor_first_name", visitorFirstName);
            formData.append("visitor_last_name", visitorLastName);
            formData.append("visitor_mobile_no", visitorMobileNo);
            formData.append("visitor_email", visitorEmailId);
            formData.append("visiting_card", visitingCard);
            formData.append("photo", photo);
            formData.append("id_proof_front", idProofFront);
            formData.append("id_proof_back", idProofBack);

            // Travel upload (Diamond + Platinum)
            if (requiresTravelTicket) {
                formData.append("travel_ticket", travelTicket);
                formData.append("departure_ticket", departureTicket);
            }



            if (showHotelSection) {
                formData.append("hotel_check_in", checkInDate);
                formData.append("hotel_check_out", checkOutDate);
                formData.append("stay_duration", nightsChoice);
            }

            if (arrivalDate) formData.append("arrival_date", arrivalDate);
            if (departureDate) formData.append("departure_date", departureDate);
            if (remarks) formData.append("remarks", remarks);

            // Travel Mode
            formData.append("travel_mode", travelMode);

            if (travelMode === "Flight") {
                if (arrivalFlightNo) formData.append("arrival_flight_no", arrivalFlightNo);
                if (departureFlightNo) formData.append("departure_flight_no", departureFlightNo);
                if (arrivalTerminal) formData.append("arrival_terminal", arrivalTerminal);
                if (departureTerminal) formData.append("departure_terminal", departureTerminal);
                if (arrivalTime) formData.append("arrival_time", arrivalTime);
                if (departureTime) formData.append("departure_time", departureTime);
            }

            await axios.put(
                `${process.env.REACT_APP_API_END_POINT}/buyer/complete-registration/${barcode}`,
                formData,
                {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem("jff_token")}`,
                        barcode: barcode
                    }

                }
            );


            setAlreadyRegistered(true);
            setRegistrationCompleted(true);

        } catch (err) {
            console.error("Registration error:", err);
            message.error(err.response?.data?.message || "Registration failed");
        } finally {
            setIsLoading(false);
        }
    };



    const handleCompanyName = (e) => {
        const newValue = e.target.value;
        const alphabetOnlyValue = newValue.replace(/[^A-Za-z ]/g, "");
        setCompanyName(alphabetOnlyValue);
    }
    const handleFirstNameChange = (e) => {
        const newValue = e.target.value;
        const alphabetOnlyValue = newValue.replace(/[^A-Za-z ]/g, "");
        setVisitorFirstName(alphabetOnlyValue);
    };
    const handleLastNameChange = (e) => {
        const newValue = e.target.value;
        const alphabetOnlyValue = newValue.replace(/[^A-Za-z ]/g, "");
        setVisitorLastName(alphabetOnlyValue);
    };
    const handleStoreNameChange = (e) => {
        const newValue = e.target.value;
        const alphabetOnlyValue = newValue.replace(/[^A-Za-z ]/g, "");
        setStoreName(alphabetOnlyValue);
    }
    const handleCity = (e) => {
        const newValue = e.target.value;
        const alphabetOnlyValue = newValue.replace(/[^A-Za-z ]/g, "");
        setCity(alphabetOnlyValue);
    };

    const handleVisitorEmailChange = (e) => {
        const value = e.target.value;
        setVisitorEmailId(value);

        const emailPattern = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;

        if (!emailPattern.test(value)) {
            setEmailError("Invalid email format");
        } else {
            setEmailError("");
        }
    };

    const handleCompanyEmailChange = (e) => {
        const value = e.target.value;
        setCompanyEmail(value);
        setCompanyEmailError("");
        const emailPattern = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;

        if (!emailPattern.test(value)) {
            setCompanyEmailError("Invalid email format");
        } else {
            setCompanyEmailError("");
        }
    }



    const handleVisitorMobileNoChange = (e) => {
        const input = e.target.value;
        const numericValue = input.replace(/\D/g, "");
        setDuplicateError(null)
        setVisitorMobileNo(numericValue);

        if (numericValue.length >= 10 && numericValue.length <= 15) {
            axios
                .get(
                    `${process.env.REACT_APP_API_END_POINT}/check-is-number/${numericValue}/visitor`
                )
                .then(({ data }) => {
                    if (data.inUse) {
                        setDuplicateError(data.message === "vip" ? "vip" : "true");
                    } else {
                        setDuplicateError(null);
                    }
                });
        }
    };

    const handleCompanyNumberChange = (e) => {
        const input = e.target.value;
        const numericValue = input.replace(/\D/g, "");
        setCompanyNumber(numericValue);
        setCompanyNumberError(null)

        if (numericValue.length >= 10) {
            axios
                .get(
                    `${process.env.REACT_APP_API_END_POINT}/check-is-number/${numericValue}/visitor`
                )
                .then(({ data }) => {
                    if (data.inUse) {
                        setCompanyNumberError(data.message === "vip" ? "vip" : "true");
                    } else {
                        setCompanyNumberError(null);
                    }
                });
        }
    }
    const getImageSrc = (file, folder) => {
        if (!file) return null;

        // If user just uploaded file
        if (file instanceof File) {
            return URL.createObjectURL(file);
        }

        // If file is from backend (string filename)
        return `${process.env.REACT_APP_IMAGE_URL}/${folder}/${file}`;
    };


    const calculateCheckoutDate = (checkIn, nights) => {
        if (!checkIn || !nights) return "";

        const start = new Date(checkIn);
        const checkout = new Date(start);
        checkout.setDate(start.getDate() + nights);

        const hotelEnd = new Date(HOTEL_END_DATE);

        // prevent overflow beyond hotel end date
        if (checkout > hotelEnd) {
            return HOTEL_END_DATE;
        }

        return checkout.toISOString().split("T")[0]; // yyyy-mm-dd
    };


    //   useEffect(() => {
    //     axios
    //       .get(`${process.env.REACT_APP_API_END_POINT}/exhibitor-lists-data`)
    //       .then((resData) => {
    //         setComapnyList(resData.data.data);
    //       });
    //   }, []);

    // ⛔ Access guard
    if (accessAllowed === null) {
        return (
            <div style={{
                minHeight: "100vh",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                fontSize: "18px"
            }}>
                Loading...
            </div>
        );
    }

    if (accessAllowed === false) {
        return (
            <div style={{
                minHeight: "100vh",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flexDirection: "column",
                background: "#f5f6f7",
                textAlign: "center",
                padding: "20px"
            }}>
                <h2 style={{ color: "#c0392b" }}>Access Denied</h2>
                <p style={{ fontSize: "18px", marginTop: "10px" }}>{accessError}</p>
            </div>
        );
    }
    if (alreadyRegistered) {
        return (
            <div style={{
                minHeight: "100vh",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                background: "#f5f6f7"
            }}>
                <div style={{
                    background: "#fff",
                    padding: "40px",
                    borderRadius: "12px",
                    textAlign: "center",
                    maxWidth: "520px",
                    boxShadow: "0 10px 30px rgba(0,0,0,0.1)"
                }}>
                    <img
                        src={logoUrl || MainLogo}
                        alt={process.env.REACT_APP_ORGANIZER_NAME}
                        style={{
                            height: "220px",
                            width: "auto",
                            marginBottom: "20px",
                            objectFit: "contain"
                        }}
                    />
                    <h2 style={{ color: "#2c3e50" }}>Registration Completed</h2>
                    <p style={{ marginTop: "15px", fontSize: "17px", color: "#555" }}>
                        You have successfully registered for the show.
                    </p>
                </div>
            </div>
        );
    }


    return (
        <>
            <div>
                <div className="container-fluid">
                    <div className="row vh-100">
                        <div className="col-lg-5 col-md-12 d-lg-block p-0 img-col" style={{ position: "fixed" }}>
                            <img
                                src={backgroundUrl || backgroundImage}
                                alt="Placeholder"
                                className="img-fluid vh-100 w-60 top-img px-3 p-lg-5"
                            />
                        </div>
                        <div
                            className="col-lg-7 col-md-12 d-flex justify-content-center align-items-center form-col"
                            style={{
                                position: "absolute",
                                right: "0px",
                                borderLeft: "2px solid #e5e5e5"
                            }}
                        >
                            {showSuccessPage ? (
                                <>
                                    {" "}
                                    <PrintPage
                                        barcode={localStorage.getItem("barcode")}
                                        text={"Your registration is successfully completed."}
                                    />
                                </>
                            ) : (
                                <form className="w-100 px-4">
                                    <div className="text-aling-center">

                                        <img
                                            src={logoUrl || MainLogo}
                                            alt={process.env.REACT_APP_ORGANIZER_NAME}
                                            className="logo-img"
                                            style={{
                                                height: "250px",
                                                width: "280px",
                                                objectFit: "contain",
                                                display: "flex",
                                                margin: "0px auto 10px",
                                            }}
                                        />


                                        <h4
                                            className="text-center mb-3"
                                            style={{ marginTop: "15px" }}
                                        >
                                            Visitor Registration Form
                                        </h4>
                                    </div>
                                    {/* Form Inputs */}

                                    {visibilityLoading ? (
                                        <div className="w-100 p-2">
                                            <style>{`
                                                @keyframes skeletonShimmer {
                                                    0% { background-position: -200px 0; }
                                                    100% { background-position: 200px 0; }
                                                }
                                                .skeleton-box {
                                                    background: #e8e8e8;
                                                    background-image: linear-gradient(90deg, #e8e8e8 0px, #f5f5f5 40px, #e8e8e8 80px);
                                                    background-size: 300px 100%;
                                                    animation: skeletonShimmer 1.5s infinite linear;
                                                    border-radius: 4px;
                                                }
                                            `}</style>
                                            <div className="mb-4">
                                                <div className="skeleton-box mb-2" style={{ width: "120px", height: "18px" }}></div>
                                                <div className="d-flex gap-4">
                                                    <div className="skeleton-box" style={{ width: "90px", height: "22px", borderRadius: "12px" }}></div>
                                                    <div className="skeleton-box" style={{ width: "90px", height: "22px", borderRadius: "12px" }}></div>
                                                    <div className="skeleton-box" style={{ width: "90px", height: "22px", borderRadius: "12px" }}></div>
                                                </div>
                                            </div>
                                            <div className="row g-3">
                                                {[1, 2, 3, 4, 5, 6].map((i) => (
                                                    <div key={i} className="col-lg-6 col-12 mb-3">
                                                        <div className="skeleton-box mb-2" style={{ width: "40%", height: "16px" }}></div>
                                                        <div className="skeleton-box" style={{ width: "100%", height: "38px" }}></div>
                                                    </div>
                                                ))}
                                            </div>
                                            <div className="mt-4 col-12">
                                                <div className="skeleton-box w-100" style={{ height: "45px", borderRadius: "4px" }}></div>
                                            </div>
                                        </div>
                                    ) : registrationCompleted || (showData && showData.visitor === "active") ? (
                                        <div className="row">
                                            <div className="row">
                                                <div className="col-12 mb-3">
                                                    <label className="fw-bold fs-5 mb-2 d-block">
                                                        Show <font color="#FF0000">*</font>
                                                    </label>
                                                    <div className="d-flex align-items-center gap-4 mt-2">
                                                        <label className="d-flex align-items-center gap-2 me-4 cursor-pointer">
                                                            <input
                                                                type="radio"
                                                                name="show_option"
                                                                value="Hyderabad"
                                                                checked={selectedShow === "Hyderabad"}
                                                                onChange={(e) => setSelectedShow(e.target.value)}
                                                                disabled={lockBuyerFields && Boolean(prefilledData?.show)}
                                                            />
                                                            <span>Hyderabad</span>
                                                        </label>
                                                        <label className="d-flex align-items-center gap-2 me-4 cursor-pointer">
                                                            <input
                                                                type="radio"
                                                                name="show_option"
                                                                value="Delhi"
                                                                checked={selectedShow === "Delhi"}
                                                                onChange={(e) => setSelectedShow(e.target.value)}
                                                                disabled={lockBuyerFields && Boolean(prefilledData?.show)}
                                                            />
                                                            <span>Delhi</span>
                                                        </label>
                                                        <label className="d-flex align-items-center gap-2 cursor-pointer">
                                                            <input
                                                                type="radio"
                                                                name="show_option"
                                                                value="Both"
                                                                checked={selectedShow === "Both"}
                                                                onChange={(e) => setSelectedShow(e.target.value)}
                                                                disabled={lockBuyerFields && Boolean(prefilledData?.show)}
                                                            />
                                                            <span>Both</span>
                                                        </label>
                                                    </div>
                                                </div>
                                                <div className="col-lg-6 col-12 regis-form-group">
                                                    <label className="fw-bold">
                                                        Gst Number <font color="#FF0000">*</font>
                                                    </label>
                                                    <input
                                                        type="text"
                                                        placeholder="Gst Number"
                                                        value={gst_number}
                                                        className="form-control my-2"
                                                        disabled={
                                                            lockBuyerFields ||
                                                            duplicateError === "vip" ||
                                                            duplicateError === "true"
                                                        }
                                                        style={getPrefilledStyle(gst_number)}

                                                        onChange={handleGstNumberChange}
                                                    />
                                                    {showError && (
                                                        <p className="text-danger">{showError}</p>
                                                    )}
                                                </div>
                                                <div className="col-lg-6 col-12 regis-form-group">
                                                    <label className="fw-bold">
                                                        Company Name <font color="#FF0000">*</font>
                                                    </label>
                                                    <input
                                                        type="text"
                                                        placeholder="Company Name"
                                                        className="form-control my-2"
                                                        disabled={
                                                            duplicateError === "vip" ||
                                                            duplicateError === "true" ||
                                                            gst_data_present?.company
                                                        }
                                                        style={{
                                                            background: `${duplicateError === "vip" ||
                                                                duplicateError === "true" ||
                                                                gst_data_present?.company
                                                                ? "#cdcdcd"
                                                                : "#fff"
                                                                }`,
                                                        }}
                                                        value={companyName}
                                                        onChange={(e) => {
                                                            handleCompanyName(e);
                                                        }}
                                                    />

                                                </div>
                                                <div className="col-lg-6 col-12 mb-3">
                                                    <label className="fw-bold">
                                                        Store Name <font color="#FF0000">*</font>
                                                    </label>
                                                    <input
                                                        type="text"
                                                        placeholder="Store Name"
                                                        value={storeName}
                                                        disabled={prefilledStoreName}
                                                        style={{ background: prefilledStoreName ? "#cdcdcd" : "#fff" }}

                                                        className="form-control my-2"
                                                        onChange={handleStoreNameChange}
                                                    />


                                                </div>
                                                <div className="col-lg-6 col-12 regis-form-group mt-2">
                                                    <label className="fw-bold">
                                                        Company Address <font color="#FF0000">*</font>
                                                    </label>
                                                    <input
                                                        type="text"
                                                        disabled={
                                                            duplicateError === "vip" ||
                                                            duplicateError === "true" ||
                                                            gst_data_present?.address
                                                        }
                                                        style={{
                                                            background: `${duplicateError === "vip" ||
                                                                duplicateError === "true" ||
                                                                gst_data_present?.address
                                                                ? "#cdcdcd"
                                                                : "#fff"
                                                                }`,
                                                        }}
                                                        placeholder="Address"
                                                        className="form-control my-2"
                                                        value={companyAddress}
                                                        onChange={(e) => {
                                                            setCompanyAddress(e.target.value);
                                                        }}
                                                    />
                                                </div>
                                                <div className="col-lg-6 col-12 regis-form-group">
                                                    <label className="fw-bold">
                                                        City <font color="#FF0000">*</font>
                                                    </label>
                                                    <input
                                                        type="text"
                                                        placeholder="City"
                                                        className="form-control my-2"
                                                        disabled={
                                                            duplicateError === "vip" ||
                                                            duplicateError === "true" ||
                                                            gst_data_present?.city
                                                        }
                                                        style={{
                                                            background: `${duplicateError === "vip" ||
                                                                duplicateError === "true" ||
                                                                gst_data_present?.city
                                                                ? "#cdcdcd"
                                                                : "#fff"
                                                                }`,
                                                        }}
                                                        value={city}
                                                        onChange={(e) => {
                                                            handleCity(e);
                                                        }}
                                                    />
                                                </div>
                                                <div className="col-lg-6 col-12 regis-form-group">
                                                    <label className="fw-bold">
                                                        State <font color="#FF0000">*</font>
                                                    </label>
                                                    <input
                                                        type="text"
                                                        placeholder="State"
                                                        className="form-control my-2"
                                                        disabled={
                                                            duplicateError === "vip" ||
                                                            duplicateError === "true" ||
                                                            gst_data_present?.state
                                                        }
                                                        style={{
                                                            background: `${duplicateError === "vip" ||
                                                                duplicateError === "true" ||
                                                                gst_data_present?.state
                                                                ? "#cdcdcd"
                                                                : "#fff"
                                                                }`,
                                                        }}
                                                        value={state}
                                                        onChange={(e) => {
                                                            setState(e.target.value);
                                                        }}
                                                    />
                                                </div>
                                                <div className="col-lg-6 col-12 regis-form-group">
                                                    <label className="fw-bold">
                                                        Country <font color="#FF0000">*</font>
                                                    </label>
                                                    <input
                                                        type="text"
                                                        placeholder="Country"
                                                        className="form-control my-2"
                                                        disabled={
                                                            duplicateError === "vip" ||
                                                            duplicateError === "true" ||
                                                            gst_data_present?.state
                                                        }
                                                        style={{
                                                            background: `${duplicateError === "vip" ||
                                                                duplicateError === "true" ||
                                                                gst_data_present?.state
                                                                ? "#cdcdcd"
                                                                : "#fff"
                                                                }`,
                                                        }}
                                                        value={country}
                                                        onChange={(e) => {
                                                            setCountry(e.target.value);
                                                        }}
                                                    />
                                                </div>
                                                <div className="col-lg-6 col-12 regis-form-group">
                                                    <label className="fw-bold">
                                                        Zip code <font color="#FF0000">*</font>
                                                    </label>
                                                    <input
                                                        type="text"
                                                        placeholder="Pincode"
                                                        className="form-control my-2"
                                                        name="zip_code"
                                                        disabled={
                                                            duplicateError === "vip" ||
                                                            duplicateError === "true" ||
                                                            gst_data_present?.pincode
                                                        }
                                                        style={{
                                                            background: `${duplicateError === "vip" ||
                                                                duplicateError === "true" ||
                                                                gst_data_present?.pincode
                                                                ? "#cdcdcd"
                                                                : "#fff"
                                                                }`,
                                                        }}
                                                        value={zip}
                                                        onChange={(e) => {
                                                            setZip(e.target.value);
                                                        }}
                                                    />
                                                </div>
                                                <div className="col-lg-6 col-12 mb-3">
                                                    <label className="fw-bold">
                                                        Company Email <font color="#FF0000">*</font>
                                                    </label>
                                                    <input
                                                        type="text"
                                                        value={companyEmail}
                                                        placeholder="Company Email"
                                                        disabled={prefilledCompanyEmail}
                                                        style={{ background: prefilledCompanyEmail ? "#cdcdcd" : "#fff" }}



                                                        className="form-control my-2"
                                                        onChange={handleCompanyEmailChange}
                                                    />

                                                    {CompanyEmailError && (
                                                        <p className="text-danger">
                                                            {CompanyEmailError}
                                                        </p>
                                                    )}
                                                </div>

                                                <div className="col-lg-6 col-12 mb-3">
                                                    <label className="fw-bold">
                                                        Company Number <font color="#FF0000">*</font>
                                                    </label>
                                                    <input
                                                        type="text"
                                                        value={companyNumber}
                                                        placeholder="Company Mobile"
                                                        disabled={prefilledCompanyNumber}
                                                        style={{
                                                            background: prefilledCompanyNumber ? "#cdcdcd" : "#fff",
                                                            color: "#000"
                                                        }}

                                                        className="form-control my-2"
                                                        onChange={handleCompanyNumberChange}
                                                    />

                                                    {CompanyNumberError === "true" && (
                                                        <p className="text-danger">
                                                            This Number is already registered.
                                                        </p>
                                                    )}
                                                </div>
                                                <div className="col-lg-6 col-12 regis-form-group mb-3">
                                                    <label className="fw-bold">
                                                        Visiting Card <font color="#FF0000">*</font>
                                                    </label>
                                                    <input
                                                        type="file"
                                                        accept=".jpg,.jpeg,.png"
                                                        ref={visitingCardInputRef}
                                                        style={{ display: "none" }}
                                                        onChange={handleVistingCard}
                                                    />

                                                    {visitingCard ? (
                                                        <div
                                                            style={{
                                                                ...styles.imageDiv,
                                                                cursor: prefilledVisitingCard ? "default" : "pointer",
                                                                pointerEvents: prefilledVisitingCard ? "none" : "auto"
                                                            }}
                                                            onClick={() => {
                                                                if (!prefilledVisitingCard) visitingCardInputRef.current.click();
                                                            }}
                                                            title={prefilledVisitingCard ? "Image locked" : "Click to change visiting card"}
                                                        >
                                                            <img
                                                                src={getImageSrc(visitingCard, "visiting_card")}
                                                                style={styles.previewImg}
                                                            />
                                                        </div>
                                                    ) : (
                                                        <CommonFileUploader
                                                            handlePhoto={handleVistingCard}
                                                            fileName="Select File"
                                                            accept=".jpg, .jpeg, .png"
                                                            loading={visitingCardLoading}
                                                        />
                                                    )}






                                                </div>
                                                <div className="col-lg-6 col-12 regis-form-group mb-3">
                                                    <label className="fw-bold">
                                                        Store Image<font color="#FF0000">*</font>
                                                    </label>
                                                    <input
                                                        type="file"
                                                        accept=".jpg,.jpeg,.png"
                                                        ref={storeInputRef}
                                                        style={{ display: "none" }}
                                                        onChange={handleStoreImage}
                                                    />

                                                    {storeImage ? (
                                                        <div
                                                            style={{
                                                                ...styles.imageDiv,
                                                                cursor: prefilledStoreImage ? "default" : "pointer",
                                                                pointerEvents: prefilledStoreImage ? "none" : "auto"
                                                            }}
                                                            onClick={() => {
                                                                if (!prefilledStoreImage) storeInputRef.current.click();
                                                            }}
                                                            title={prefilledStoreImage ? "Image locked" : "Click to change store image"}
                                                        >
                                                            <img
                                                                src={getImageSrc(storeImage, "store")}
                                                                style={styles.previewImg}
                                                            />
                                                        </div>
                                                    ) : (
                                                        <CommonFileUploader
                                                            handlePhoto={handleStoreImage}
                                                            fileName="Select File"
                                                            accept=".jpg, .jpeg, .png"
                                                            loading={storeImgLoading}
                                                        />
                                                    )}




                                                </div>

                                                <hr />

                                                <h3 className="mb-3">Which jewellery categories would you like to explore at the show? *</h3>

                                                <div className="row mb-3">
                                                    {categoriesList.map((cat, index) => {
                                                        const isChecked = selectedCategories.includes(cat);

                                                        // 🔒 Lock ONLY if data came from API (visitor → buyer flow)
                                                        const isLocked = prefilledCategories.length > 0;

                                                        return (
                                                            <div className="col-6" key={index}>
                                                                <label
                                                                    style={{
                                                                        fontWeight: isChecked ? "600" : "400",
                                                                        color: isLocked && isChecked ? "#111" : "#000",
                                                                        opacity: isLocked && !isChecked ? 0.4 : 1,
                                                                        cursor: isLocked ? "not-allowed" : "pointer",
                                                                        userSelect: "none"
                                                                    }}
                                                                >
                                                                    <input
                                                                        type="checkbox"
                                                                        value={cat}
                                                                        checked={isChecked}
                                                                        disabled={isLocked}   // 🔒 only locked for prefilled buyers
                                                                        onChange={(e) => {
                                                                            if (isLocked) return;

                                                                            const value = e.target.value;
                                                                            setSelectedCategories((prev) =>
                                                                                prev.includes(value)
                                                                                    ? prev.filter((c) => c !== value)
                                                                                    : [...prev, value]
                                                                            );
                                                                        }}
                                                                        style={{
                                                                            accentColor: isLocked && isChecked ? "#111" : "#000",
                                                                            cursor: isLocked ? "not-allowed" : "pointer"
                                                                        }}
                                                                    />
                                                                    {" "}
                                                                    {cat}
                                                                </label>
                                                            </div>
                                                        );
                                                    })}

                                                </div>


                                                <hr />

                                                <h3 className="mb-3">Buyer Details</h3>
                                            </div>

                                            <div className="col-lg-6 col-12 regis-form-group">
                                                <label className="fw-bold">
                                                    First Name <font color="#FF0000">*</font>
                                                </label>
                                                <input
                                                    type="text"
                                                    placeholder="First Name"
                                                    value={visitorFirstName}
                                                    style={{
                                                        background: prefilledFirstName ? "#cdcdcd" : "#fff",
                                                        color: "#000"
                                                    }}
                                                    disabled={
                                                        prefilledFirstName ||
                                                        duplicateError === "vip" ||
                                                        duplicateError === "true"
                                                    }

                                                    className="form-control my-2"
                                                    onChange={(e) => {
                                                        handleFirstNameChange(e);
                                                    }}
                                                />
                                            </div>
                                            <div className="col-lg-6 col-12 regis-form-group">
                                                <label className="fw-bold">
                                                    Last Name <font color="#FF0000">*</font>
                                                </label>
                                                <input
                                                    type="text"
                                                    placeholder="Last Name"
                                                    value={visitorLastName}
                                                    style={getPrefilledStyle(visitorLastName)}

                                                    disabled={
                                                        isBuyerFlow ||
                                                        duplicateError === "vip" ||
                                                        duplicateError === "true"
                                                    }
                                                    className="form-control my-2"
                                                    onChange={(e) => {
                                                        handleLastNameChange(e);
                                                    }}
                                                />
                                            </div>
                                            <div className="col-lg-6 col-12 regis-form-group">
                                                <label className="fw-bold">
                                                    Mobile No. <font color="#FF0000">*</font>
                                                </label>
                                                <input
                                                    type="text"
                                                    value={visitorMobileNo}
                                                    placeholder="Mobile"
                                                    disabled={prefilledVisitorMobile}
                                                    style={{ background: prefilledVisitorMobile ? "#cdcdcd" : "#fff" }}

                                                    className="form-control my-2"
                                                    //   maxLength={userType === "india" ? 10 : 15}
                                                    onChange={handleVisitorMobileNoChange}
                                                />
                                                {duplicateError === "true" && (
                                                    <p className="text-danger">
                                                        This Number is already registered.
                                                    </p>
                                                )}
                                                {duplicateError === "vip" && (
                                                    <p className="text-danger">
                                                        You already Registered as Buyer
                                                    </p>
                                                )}
                                                {duplicateError === "false" && (
                                                    <p className="text-success">
                                                        This number is available.
                                                    </p>
                                                )}
                                            </div>
                                            <div className="col-lg-6 col-12 regis-form-group">
                                                <label className="fw-bold">
                                                    Email <font color="#FF0000">*</font>
                                                </label>
                                                <input
                                                    type="text"
                                                    value={visitorEmailId}
                                                    placeholder="Email"
                                                    disabled={prefilledVisitorEmail}
                                                    style={{ background: prefilledVisitorEmail ? "#cdcdcd" : "#fff" }}

                                                    className="form-control my-2"
                                                    onChange={handleVisitorEmailChange}
                                                />

                                                {emailError && (
                                                    <p className="text-danger">
                                                        {emailError}
                                                    </p>
                                                )}
                                            </div>

                                            <div className="col-lg-6 col-12 regis-form-group">
                                                <label className="fw-bold">
                                                    Upload Pic <font color="#FF0000">*</font>
                                                </label>

                                                {/* Hidden input */}
                                                <input
                                                    type="file"
                                                    accept=".jpg,.jpeg,.png"
                                                    ref={photoInputRef}
                                                    style={{ display: "none" }}
                                                    onChange={handlePhoto}
                                                />

                                                {photo ? (
                                                    <div
                                                        style={{
                                                            ...styles.imageDiv,
                                                            cursor: prefilledPhoto ? "default" : "pointer",
                                                            pointerEvents: prefilledPhoto ? "none" : "auto"
                                                        }}
                                                        onClick={() => {
                                                            if (!prefilledPhoto) photoInputRef.current.click();
                                                        }}
                                                        title={prefilledPhoto ? "Image locked" : "Click to change photo"}
                                                    >
                                                        <img
                                                            src={getImageSrc(photo, "photo")}
                                                            style={styles.previewImg}
                                                        />
                                                    </div>
                                                ) : (
                                                    <CommonFileUploader
                                                        handlePhoto={(e) => handlePhoto(e)}
                                                        fileName="Select File"
                                                        accept=".jpg, .jpeg, .png"
                                                        loading={photoLoading}
                                                    />
                                                )}
                                            </div>

                                            <div className="col-lg-6 col-12 regis-form-group">
                                                <label className="fw-bold">
                                                    Upload ID Front <font color="#FF0000">*</font>
                                                </label>
                                                <input
                                                    type="file"
                                                    accept=".jpg,.jpeg,.png"
                                                    ref={idFrontInputRef}
                                                    style={{ display: "none" }}
                                                    onChange={handleIDFront}
                                                />

                                                {idProofFront ? (
                                                    <div
                                                        style={{
                                                            ...styles.imageDiv,
                                                            cursor: prefilledIdProofFront ? "default" : "pointer",
                                                            pointerEvents: prefilledIdProofFront ? "none" : "auto"
                                                        }}
                                                        onClick={() => {
                                                            if (!prefilledIdProofFront) idFrontInputRef.current.click();
                                                        }}
                                                        title={prefilledIdProofFront ? "Image locked" : "Click to change ID front"}
                                                    >
                                                        <img
                                                            src={getImageSrc(idProofFront, "id_front")}
                                                            style={styles.previewImg}
                                                        />
                                                    </div>
                                                ) : (
                                                    <CommonFileUploader
                                                        handlePhoto={handleIDFront}
                                                        fileName="Select File"
                                                        accept=".jpg, .jpeg, .png"
                                                        loading={idFrontLoading}
                                                    />
                                                )}

                                            </div>
                                            <div className="col-lg-6 col-12 regis-form-group mb-3">
                                                <label className="fw-bold">
                                                    Upload ID Back <font color="#FF0000">*</font>
                                                </label>
                                                <input
                                                    type="file"
                                                    accept=".jpg,.jpeg,.png"
                                                    ref={idBackInputRef}
                                                    style={{ display: "none" }}
                                                    onChange={handleIDBack}
                                                />

                                                {idProofBack ? (
                                                    <div
                                                        style={{
                                                            ...styles.imageDiv,
                                                            cursor: prefilledIdProofBack ? "default" : "pointer",
                                                            pointerEvents: prefilledIdProofBack ? "none" : "auto"
                                                        }}
                                                        onClick={() => {
                                                            if (!prefilledIdProofBack) idBackInputRef.current.click();
                                                        }}
                                                        title={prefilledIdProofBack ? "Image locked" : "Click to change ID back"}
                                                    >
                                                        <img
                                                            src={getImageSrc(idProofBack, "id_back")}
                                                            style={styles.previewImg}
                                                        />
                                                    </div>
                                                ) : (
                                                    <CommonFileUploader
                                                        handlePhoto={handleIDBack}
                                                        fileName="Select File"
                                                        accept=".jpg, .jpeg, .png"
                                                        loading={idBackLoading}
                                                    />
                                                )}

                                            </div>
                                            {requiresTravelTicket && (
                                                <>
                                                    <hr />
                                                    <h3 className="mb-3">Travel Details</h3>
                                                    <p className="text-muted mb-3" style={{ backgroundColor: "#f8f9fa", padding: "10px", borderRadius: "5px", borderLeft: "4px solid #333" }}>
                                                        <strong>Dear Buyer,</strong> we are pleased to inform you that you are eligible for to-and-fro travel reimbursement up to ₹15,000 for one person per company, as per show policy.(T&C apply)
                                                    </p>

                                                    <div className="col-lg-6 col-12 regis-form-group mb-3">
                                                        <label className="fw-bold d-block">Travel Mode <font color="#FF0000">*</font></label>
                                                        <select
                                                            className="form-control my-2"
                                                            value={travelMode}
                                                            onChange={(e) => setTravelMode(e.target.value)}
                                                        >
                                                            <option value="" disabled>Select Travel Mode</option>
                                                            <option value="Flight">Flight</option>
                                                            <option value="Self">Self</option>
                                                        </select>
                                                    </div>

                                                    {travelMode === 'Flight' && (
                                                        <>

                                                            <div className="col-lg-6 col-12 regis-form-group mb-3">
                                                                <label className="fw-bold">
                                                                    Arrival Date <font color="#FF0000">*</font>
                                                                </label>
                                                                <input
                                                                    type="date"
                                                                    className="form-control my-2"
                                                                    value={arrivalDate}
                                                                    min={TICKTING_START_DATE}
                                                                    max={TICKTING_END_DATE}
                                                                    onKeyDown={(e) => e.preventDefault()}
                                                                    onPaste={(e) => e.preventDefault()}
                                                                    onChange={(e) => setArrivalDate(e.target.value)}
                                                                />
                                                            </div>

                                                            <div className="col-lg-6 col-12 regis-form-group mb-3">
                                                                <label className="fw-bold">
                                                                    Departure Date <font color="#FF0000">*</font>
                                                                </label>
                                                                <input
                                                                    type="date"
                                                                    className="form-control my-2"
                                                                    value={departureDate}
                                                                    min={TICKTING_START_DATE}
                                                                    max={TICKTING_END_DATE}
                                                                    onKeyDown={(e) => e.preventDefault()}
                                                                    onPaste={(e) => e.preventDefault()}
                                                                    onChange={(e) => setDepartureDate(e.target.value)}
                                                                />
                                                            </div>

                                                            <div className="col-lg-6 col-12 regis-form-group mb-3">
                                                                <label className="fw-bold">
                                                                    Arrival Flight No <font color="#FF0000">*</font>
                                                                </label>
                                                                <input
                                                                    type="text"
                                                                    className="form-control my-2"
                                                                    placeholder="Arrival Flight No"
                                                                    value={arrivalFlightNo}
                                                                    onChange={(e) => setArrivalFlightNo(e.target.value)}
                                                                />
                                                            </div>

                                                            <div className="col-lg-6 col-12 regis-form-group mb-3">
                                                                <label className="fw-bold">
                                                                    Arrival Terminal <font color="#FF0000">*</font>
                                                                </label>
                                                                <input
                                                                    type="text"
                                                                    className="form-control my-2"
                                                                    placeholder="Arrival Terminal"
                                                                    value={arrivalTerminal}
                                                                    onChange={(e) => setArrivalTerminal(e.target.value)}
                                                                />
                                                            </div>

                                                            <div className="col-lg-6 col-12 regis-form-group mb-3">
                                                                <label className="fw-bold">
                                                                    Departure Flight No <font color="#FF0000">*</font>
                                                                </label>
                                                                <input
                                                                    type="text"
                                                                    className="form-control my-2"
                                                                    placeholder="Departure Flight No"
                                                                    value={departureFlightNo}
                                                                    onChange={(e) => setDepartureFlightNo(e.target.value)}
                                                                />
                                                            </div>

                                                            <div className="col-lg-6 col-12 regis-form-group mb-3">
                                                                <label className="fw-bold">
                                                                    Departure Terminal <font color="#FF0000">*</font>
                                                                </label>
                                                                <input
                                                                    type="text"
                                                                    className="form-control my-2"
                                                                    placeholder="Departure Terminal"
                                                                    value={departureTerminal}
                                                                    onChange={(e) => setDepartureTerminal(e.target.value)}
                                                                />
                                                            </div>

                                                            <div className="col-lg-6 col-12 regis-form-group mb-3">
                                                                <label className="fw-bold">
                                                                    Arrival Time <font color="#FF0000">*</font>
                                                                </label>
                                                                <input
                                                                    type="time"
                                                                    className="form-control my-2"
                                                                    value={arrivalTime}
                                                                    onChange={(e) => setArrivalTime(e.target.value)}
                                                                />
                                                            </div>

                                                            <div className="col-lg-6 col-12 regis-form-group mb-3">
                                                                <label className="fw-bold">
                                                                    Departure Time <font color="#FF0000">*</font>
                                                                </label>
                                                                <input
                                                                    type="time"
                                                                    className="form-control my-2"
                                                                    value={departureTime}
                                                                    onChange={(e) => setDepartureTime(e.target.value)}
                                                                />
                                                            </div>

                                                            <div className="col-lg-6 col-12 regis-form-group mb-3">
                                                                <label className="fw-bold">
                                                                    Upload Arrival Ticket <font color="#FF0000">*</font>
                                                                </label>

                                                                <CommonFileUploader
                                                                    handlePhoto={handleTravelTicket}
                                                                    fileName={
                                                                        travelTicket ? (travelTicket?.name || travelTicket) : "Select Travel Ticket"
                                                                    }
                                                                    accept=".jpg, .jpeg, .png"
                                                                    loading={travelLoading}
                                                                />

                                                                {travelTicket instanceof File && (
                                                                    <div style={styles.imageDiv}>
                                                                        <img
                                                                            src={URL.createObjectURL(travelTicket)}
                                                                            alt="Preview"
                                                                            style={styles.previewImg}
                                                                        />
                                                                    </div>
                                                                )}
                                                                {!(travelTicket instanceof File) && travelTicket && (
                                                                    <div style={styles.imageDiv}>
                                                                        <img
                                                                            src={`${process.env.REACT_APP_IMAGE_URL}/travel_ticket/${travelTicket}`}
                                                                            alt="Preview"
                                                                            style={styles.previewImg}
                                                                        />
                                                                    </div>
                                                                )}
                                                            </div>

                                                            <div className="col-lg-6 col-12 regis-form-group mb-3">
                                                                <label className="fw-bold">
                                                                    Upload Departure Ticket
                                                                </label>

                                                                <CommonFileUploader
                                                                    handlePhoto={handleDepartureTicket}
                                                                    fileName={
                                                                        departureTicket ? (departureTicket?.name || departureTicket) : "Select Departure Ticket"
                                                                    }
                                                                    accept=".jpg, .jpeg, .png"
                                                                    loading={departureLoading}
                                                                />

                                                                {departureTicket instanceof File && (
                                                                    <div style={styles.imageDiv}>
                                                                        <img
                                                                            src={URL.createObjectURL(departureTicket)}
                                                                            alt="Preview"
                                                                            style={styles.previewImg}
                                                                        />
                                                                    </div>
                                                                )}
                                                                {!(departureTicket instanceof File) && departureTicket && (
                                                                    <div style={styles.imageDiv}>
                                                                        <img
                                                                            src={`${process.env.REACT_APP_IMAGE_URL}/travel_ticket/${departureTicket}`}
                                                                            alt="Preview"
                                                                            style={styles.previewImg}
                                                                        />
                                                                    </div>
                                                                )}

                                                            </div>
                                                        </>
                                                    )}
                                                </>
                                            )}

                                            {showHotelSection && (

                                                <>
                                                    <hr />
                                                    <h3 classaName="mb-2">Hotel Details</h3>

                                                    <p className="text-muted mb-3" style={{ backgroundColor: "#f8f9fa", padding: "10px", borderRadius: "5px", borderLeft: "4px solid #333" }}>
                                                        <strong>Dear Buyer ,</strong> you're eligible for a {maxHotelNights}-night{maxHotelNights > 1 ? "s" : ""} stay as per the show policy.{" "}
                                                    </p>
                                                    {!isGoldMember && (
                                                        <div className="col-12 regis-form-group mb-2">
                                                            <label className="fw-bold d-block">Select Stay Duration <font color="#FF0000">*</font></label>
                                                            <div className="form-check form-check-inline">
                                                                <input
                                                                    className="form-check-input"
                                                                    type="radio"
                                                                    name="stayDuration"
                                                                    id="nights2"
                                                                    value={2}
                                                                    checked={nightsChoice === 2}
                                                                    onChange={() => {
                                                                        setNightsChoice(2);
                                                                        setCheckInDate("");
                                                                        setCheckOutDate("");
                                                                    }}
                                                                />
                                                                <label className="form-check-label" htmlFor="nights2">2 Nights</label>
                                                            </div>
                                                            <div className="form-check form-check-inline">
                                                                <input
                                                                    className="form-check-input"
                                                                    type="radio"
                                                                    name="stayDuration"
                                                                    id="nights1"
                                                                    value={1}
                                                                    checked={nightsChoice === 1}
                                                                    onChange={() => {
                                                                        setNightsChoice(1);
                                                                        setCheckInDate("");
                                                                        setCheckOutDate("");
                                                                    }}
                                                                />
                                                                <label className="form-check-label" htmlFor="nights1">1 Night</label>
                                                            </div>
                                                        </div>
                                                    )}


                                                    <div className="col-lg-6 col-12 regis-form-group">
                                                        <label className="fw-bold">
                                                            Expected Check-in Date <font color="#FF0000">*</font>
                                                        </label>
                                                        <input
                                                            type="date"
                                                            className="form-control my-2"
                                                            value={checkInDate}
                                                            min={HOTEL_START_DATE}
                                                            max={HOTEL_END_DATE}
                                                            onKeyDown={(e) => e.preventDefault()}
                                                            onPaste={(e) => e.preventDefault()}
                                                            onChange={(e) => {
                                                                const selectedDate = e.target.value;
                                                                setCheckInDate(selectedDate);

                                                                if (nightsChoice > 0) {
                                                                    const autoCheckout = calculateCheckoutDate(selectedDate, nightsChoice);
                                                                    setCheckOutDate(autoCheckout);
                                                                }
                                                            }}
                                                        />
                                                    </div>

                                                    <div className="col-lg-6 col-12 regis-form-group">
                                                        <label className="fw-bold">
                                                            Expected Check-out Date <font color="#FF0000">*</font>
                                                        </label>
                                                        <input
                                                            type="date"
                                                            className="form-control my-2"
                                                            value={checkOutDate}
                                                            disabled
                                                            style={{ background: "#eaeaea", cursor: "not-allowed" }}
                                                        />

                                                    </div>
                                                </>
                                            )}






                                            <div className="col-12 form-group mb-3">
                                                <label className="fw-bold">Extra Requirements and Recommendations</label>
                                                <textarea
                                                    className="form-control"
                                                    rows="3"
                                                    value={remarks}
                                                    onChange={(e) => setRemarks(e.target.value)}
                                                    placeholder="Enter any extra requirements or recommendations..."
                                                ></textarea>
                                            </div>

                                            <div className="col-12 form-group mb-3 mt-3">
                                                <Button
                                                    type="button"
                                                    className="regis w-100"
                                                    style={{ backgroundColor: "#fff" }}
                                                    onClick={handleSubmit}
                                                    disabled={
                                                        isLoading ||
                                                        duplicateError === "vip" ||
                                                        duplicateError === "true" ||
                                                        CompanyEmailError || emailError
                                                    }
                                                >
                                                    {isLoading ? (
                                                        <Spinner animation="border" size="sm" />
                                                    ) : (
                                                        "Register"
                                                    )}
                                                </Button>
                                            </div>

                                        </div>
                                    ) : (
                                        // <div className="container text-center my-5">
                                        //     <div className="card shadow-lg p-3 mb-5 bg-white rounded">
                                        //         <div className="card-body">
                                        //             <h1 className="card-title text-danger">
                                        //                 Visitor Registration Suspended
                                        //             </h1>
                                        //             <p className="card-text text-muted">
                                        //                 We apologize for the inconvenience. The visitor
                                        //                 registration is currently suspended. Please check
                                        //                 back later.
                                        //             </p>
                                        //             <div className="mt-4">
                                        //                 <a href="/" className="btn btn-success">
                                        //                     Go to Homepage
                                        //                 </a>
                                        //             </div>
                                        //         </div>
                                        //     </div>
                                        // </div>
                                        <Spinner animation="border" size="sm" />
                                    )}

                                    {/* Submit Button */}
                                </form>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default BuyerVisitorForm;
